import React, { Component } from 'react'
import { Grid, Cell, Button, DatePicker, SelectField } from 'react-md';

import ReactDataGrid from 'react-data-grid';
import ApiRequestService from '../component/ApiRequestService';
import moment from 'moment';
import { CSVDownload, CSVLink } from 'react-csv';
import { Toolbar, Data } from "react-data-grid-addons";
import LoadingSpinner from '../component/LoadingSpinner';
import ColumnDropdown from '../component/ColumnDropdown';
import { AppSetting, AppProperties } from '../common/function';
import { NotificationManager } from 'react-notifications';
import { CircularProgress } from 'react-md';
import { BeatLoader } from 'react-spinners';

class ActivityLog extends Component {

    AppSetting = AppSetting();
    appProperties = AppProperties();

    constructor(props) {
        super(props);
        this.state = {
            semesters: [],
            courses: [],
            sections: [],
            selectedSemester: -1,
            selectedCourse: '',
            originalRows: [],
            filteredRows: [],
            headers: [
                { label: "ID", key: "id", id: "id", value: true },
                { label: "Feature", key: "featureName", id: "featureName", value: true },
                { label: "Assignment ID", key: "quizID", id: "quizID", value: true },
                { label: "Subject ID", key: "subjectID", id: "subjectID", value: true },
                { label: "Topic ID", key: "topicID", id: "topicID", value: true },
                { label: "Category ID", key: "categoryID", id: "categoryID", value: true },
                { label: "Assignment Name", key: "quizName", id: "quizName", value: true },
                { label: "Category Name", key: "categoryName", id: "categoryName", value: true },
                { label: "Activity Type", key: "activityType", id: "activityType", value: true },
                { label: "Log", key: "log", id: "log", value: true },
                { label: "Log Time", key: "logTime", id: "logTime", value: true },
                { label: "Performed By", key: "performedBy", id: "performedBy", value: true },
                { label: "To", key: "to", id: "to", value: true },
                { label: "To Value", key: "toVal", id: "toVal", value: true },
                
            ],
            columns: [
                { key: 'id', name: 'ID', width: 50 },
                { key: 'featureName', name: 'Feature', width: 100},
                { key: 'quizID', name: 'Assignment ID', width: 100, formatter: (row) => row.value === 0 ? '-' : row.value },
                { key: 'subjectID', name: 'Subject ID', width: 80, formatter: (row) => row.value === 0 ? '-' : row.value },
                { key: 'topicID', name: 'Topic ID', width: 80, formatter: (row) => row.value === 0 ? '-' : row.value },
                { key: 'categoryID', name: 'Category ID', width: 100, formatter: (row) => row.value === 0 ? '-' : row.value },
                { key: 'quizName', name: 'Assignment Name', width: 150 },
                { key: 'categoryName', name: 'Category Name', width: 300 },
                { key: 'activityType', name: 'Activity Type', width: 200, },
                { key: 'log', name: 'Log', width: 200, },
                {
                    key: 'logTime', name: 'Log Time', width: 200, formatter: (row) => {
                        return moment(row.value).format('YYYY-MM-DD, hh:mm:ss a')
                    }
                },
                { key: 'performedBy', name: 'Performed By', width: 180, filterable: true },
                { key: 'to', name: 'To', width: 200, },
                { key: 'toVal', name: 'To Value', formatter: (row) => row.value === 0 ? '-' : row.value },
                
            ],
            filters: {},
            semesterLoading: false,
            courseLoading: false,
            sectionLoading: false,
            tableLoading: false,
            fromDate: moment().subtract(7, 'days'),
            toDate: moment(),
        }

        this.getActivityLog = this.getActivityLog.bind(this);
    }

    clearAllNotifications() {
        NotificationManager.listNotify.forEach(n => {
            NotificationManager.remove({ id: n.id })
        });
    }

    componentDidMount() {
        // this.getActivityLog()
        this.getAllSemesters()
    }

    getAllSemesters() {
        this.clearAllNotifications()

        this.setState({
            semesterLoading: true,
        })

        let responsePromise = ApiRequestService({
            method: 'post',
            url: '/getAllSemesters',
        })

        responsePromise.then(res => {
            console.debug("res", res);
            if (res && res.data && res.data.data) {
                let semesterArr = []
                let currentSemesterID = -1;
                semesterArr = res.data.data.map(sem => {
                    if (sem.isCurrent) {
                        currentSemesterID = sem.id
                    }
                    return {
                        value: sem.id,
                        ...sem
                    }
                })
                this.setState({
                    semesters: semesterArr,
                    selectedSemester: currentSemesterID,
                })
                this.getAllCoursesForSemester(currentSemesterID);
            } else {
                NotificationManager.error('There are no semester', "EMPTY", 2000)
                this.setState({ semesters: []})
            }
        }).finally(() => {
            this.setState({
                semesterLoading: false,
            })
        })
    }

    getAllCoursesForSemester(semesterID) {
        this.setState({
            courses: [],
            courseLoading: true,
        })

        let responsePromise = ApiRequestService({
            method: 'post',
            url: '/getAllCoursesForSemester',
            data: {
                id: semesterID
            }
        })

        responsePromise.then(res => {
            console.debug("res", res);
            if (res && res.data && res.data.data && res.data.data.course_names) {
                let coursesArr = []
                coursesArr = res.data.data.course_names.map(course => {
                    return {
                        value: course.course_id,
                        ...course
                    }
                })
                this.setState({
                    courses: coursesArr,
                })
            } else {
                NotificationManager.error('There are no courses under this semester. Please choose a different semester', "EMPTY", 2000)
                this.setState({ courses: []})
            }
        }).finally(() => {
            this.setState({
                courseLoading: false,
            })
        })
    }

    getAllSectionsForCourse(courseID) {
        this.setState({
            sectionLoading: true,
            sections: []
        })
        console.debug("this.state.selectedSemester", this.state.selectedSemester)
        let responsePromise = ApiRequestService({
            method: 'post',
            url: '/getSectionsBySemesterAndCourse',
            data: {
                course_id: courseID,
                semesterID: this.state.selectedSemester
            }
        })

        responsePromise.then(res => {
            console.debug("res", res);
            if (res && res.data && res.data.data && res.data.data.section_names) {
                let sectionArr = []
                let sectionIDArr = []
                sectionArr = res.data.data.section_names.map(section => {
                    sectionIDArr.push(section.section_id)
                    return {
                        id: section.section_id,
                        label: section.section_name,
                        value: true, // by default make all the sections as selected 
                        ...section
                    }
                })
                console.debug("sectionArr", sectionArr, sectionIDArr)
                this.setState({
                    sections: sectionArr,
                })
                this.getActivityLog(sectionIDArr);
                
            } else {
                this.setState({ sections: []})
            }
        }).finally(() => {
            this.setState({
                sectionLoading: false,
            })
        })
    }

    getActivityLog(sectionIDArr) {
        if (sectionIDArr.length === 0) {
            NotificationManager.error('Please select atleat one section', 'SECTIONS', 2000)
            this.setState({
                originalRows: [],
                filteredRows: [],
            })
            return
        }
        this.setState({
            tableLoading: true,
        })
        let payload = {
            fromDate: this.state.fromDate ? moment(this.state.fromDate).format("YYYY-MM-DDTHH:mm:ssZ") : null,
            toDate: this.state.toDate ? moment(this.state.toDate).format("YYYY-MM-DDTHH:mm:ssZ") : null,
            sectionIDArr: sectionIDArr
        }
        let responsePromise = ApiRequestService({
            method: 'post',
            url: '/getStudentActivityLog',
            data: payload
        })

        responsePromise.then(res => {
            console.debug("res", res);
            if (res && res.data && res.data.data) {
                this.setState({
                    originalRows: res.data.data,
                    filteredRows:res.data.data,
                })
            } else {
                this.setState({ originalRows: [], filteredRows: [] })
            }
        }).finally(() => {
            this.setState({
                tableLoading: false,
            })
        })
    }

    rowGetter = (i) => {
        if (this.state.filteredRows.length > 0) {
            return this.state.filteredRows[i]
        }
        return null;
    };

    handleSetRows = (sortColumn, sortDirection) => {
        let initialRows = this.state.filteredRows
        const comparer = (a, b) => {
            if (sortDirection === "ASC") {
                return a[sortColumn] > b[sortColumn] ? 1 : -1;
            } else if (sortDirection === "DESC") {
                return a[sortColumn] < b[sortColumn] ? 1 : -1;
            }
        };
        let temp = sortDirection === "NONE" ? initialRows : [...initialRows].sort(comparer);

        this.setState({
            filteredRows: temp
        })
    }

    handleDateChange = (type, date) => {
        console.debug("type, date", type, date)

        if (type === 'from') {
            this.setState({
                fromDate: moment(date, 'DD/MM/YYYY'),
            })
        } else {
            this.setState({
                toDate: moment(date, 'DD/MM/YYYY'),
            })
        }
    }

    emptyRowView = () => {
        return (
            <div>
                <h4>No activity data</h4>
            </div>
        )
    }

    updateColumns = (optionsList) => {
        const updatedColumns = this.state.columns.map((column) => {
            const option = optionsList.find((opt) => opt.key === column.key);
            if (option) {
                column.hidden = !option.value;
            }
            return column;
        });

        this.setState({
            columns: updatedColumns,
        })
    }

    sectionOptionClicked = (optionsList) => {
        console.debug("optionsList", optionsList)
        this.setState({
            sections: optionsList
        })
    }

    sectionSelectedBadgeClicked = (optionsList) => {
        console.debug("optionsList", optionsList)
        this.setState({
            sections: optionsList
        })
    }

    optionClicked = (optionsList) => {
        console.debug("optionsList", optionsList)
        this.setState({
            headers: optionsList
        })
        this.updateColumns(optionsList)
    }

    selectedBadgeClicked = (optionsList) => {
        console.debug("optionsList", optionsList)
        this.setState({
            headers: optionsList
        })
        this.updateColumns(optionsList)
    }

    handleFilter = (filter) => {
        console.debug("filter", filter)
        let column = filter.column;
        let propertyName = column.key;

        console.debug("this.state.originalRows", this.state.originalRows)
        const filteredData = this.state.originalRows.filter(item => item[propertyName].includes(filter.filterTerm));
        console.debug("filteredData", filteredData)
        this.setState({
            filteredRows: filteredData,
        })

    }

    handleSemesterSelect = (_, index) => {
        let semesterID = this.state.semesters[index].id
        this.setState({
            selectedSemester: semesterID, 
            selectedCourse: null,
            courses: [], 
            sections: [],
            fromDate: moment().subtract(7, 'days'),
            toDate: moment()
        })
        this.getAllCoursesForSemester(semesterID)
    }

    handleCourseSelect = (_, index) => {
        let courseID = this.state.courses[index].course_id
        this.setState({
            selectedCourse: courseID,
            sections: [],
            fromDate: moment().subtract(7, 'days'),
            toDate: moment()
        })
        this.getAllSectionsForCourse(courseID)
    }

    /* handleSectionSelect = (_, index) => {
        let courseID = this.state.courses[index].course_id
        this.setState({selectedCourse: courseID})
        this.getAllSectionsForCourse(courseID)
    } */

    loader = () => {
        return <div style={{textAlign:'center', width:'100%', position:'relative'}}><BeatLoader color={'#bb0000'} size={12} /></div>
    }

    render() {

        return (
            <div>
                <Grid gutter={1} className="gradeBookPageContainer">
                    <Cell size={12}><h1>Activity Log</h1></Cell>
                    <Cell size={12}>
                        <Grid>
                            <Cell size={3} tabletSize={4} align='bottom' style={{ alignSelf: 'end' }}>
                                <label htmlFor="semester-select-field">Semester</label>
                                {this.state.semesterLoading ? this.loader() :
                                    <SelectField
                                        id="semester-select-field"
                                        itemLabel="name"
                                        placeholder="Semester"
                                        style={{
                                            width: "100%"
                                        }}
                                        menuItems={this.state.semesters}
                                        onChange={this.handleSemesterSelect}
                                        value={this.state.selectedSemester}
                                    />
                                }
                            </Cell>
                            {this.state.courseLoading ? <Cell size={6} align='bottom' style={{ alignSelf: 'end' }}>{this.loader()}</Cell> : null}
                            {this.state.courses.length ?
                                <Cell size={3} tabletSize={4} align='bottom' style={{ alignSelf: 'end' }}>
                                    <label htmlFor="course-select-field">Course</label>

                                    <SelectField
                                        id="course-select-field"
                                        itemLabel="course_name"
                                        placeholder="Course"
                                        style={{
                                            width: "100%"
                                        }}
                                        menuItems={this.state.courses}
                                        onChange={this.handleCourseSelect}
                                        value={this.state.selectedCourse}
                                    />
                                </Cell>
                                : null}
                            {this.state.sectionLoading ? <Cell size={6} align='bottom' style={{ alignSelf: 'end' }}>{this.loader()}</Cell> : null}
                            {this.state.courses.length && this.state.sections.length ?
                                <Cell size={6} tabletSize={12} align='bottom' style={{ alignSelf: 'end' }}>
                                    <label style={{
                                        display: 'inline-block',
                                        paddingBottom: '5px'
                                    }}>Sections</label>
                                    <ColumnDropdown
                                        options={this.state.sections}
                                        optionClicked={this.sectionOptionClicked.bind(this)}
                                        selectedBadgeClicked={this.sectionSelectedBadgeClicked.bind(this)}
                                    />
                                </Cell>
                                : null}
                        </Grid>
                    </Cell>

                    {this.state.courses.length && this.state.sections.length ?
                        <React.Fragment>
                            <Cell size={12}>
                                <Grid>
                                    <Cell size={3} align='middle'>
                                        <DatePicker id="fromDate"
                                            label="From Date"
                                            displayMode="portrait"
                                            value={this.state.fromDate.toDate()}
                                            onChange={(_, date) => {
                                                this.handleDateChange('from', date)
                                            }}
                                            formatOptions={{
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            }}
                                        />
                                    </Cell>
                                    <Cell size={3} align='middle'>
                                        <DatePicker id="toDate"
                                            label="To Date"
                                            displayMode="portrait"
                                            value={this.state.toDate.toDate()}
                                            onChange={(_, date) => {
                                                this.handleDateChange('to', date)
                                            }}
                                            formatOptions={{
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            }}
                                        />
                                    </Cell>
                                    <Cell size={3} align='bottom' style={{ alignSelf: 'end' }}>
                                        <Button primary raised onClick={() => {
                                            let sectionIDArr = []
                                            this.state.sections.forEach(sec => {
                                                if (sec.value && sec.section_id) {
                                                    sectionIDArr.push(sec.section_id)
                                                }
                                            })
                                            this.getActivityLog(sectionIDArr)
                                        }}>Fetch Data</Button>
                                    </Cell>
                                </Grid>
                            </Cell>
                        </React.Fragment>
                        : null
                    }
                   

                    {this.state.courses.length && this.state.sections.length ?

                        <React.Fragment>
                            <Cell size={10}>
                                
                                {/* <ColumnDropdown 
                            options={this.state.headers} 
                            optionClicked={this.optionClicked.bind(this)}
                            selectedBadgeClicked={this.selectedBadgeClicked.bind(this)}
                        /> */}
                            </Cell>
                            <Cell size={12} align='bottom'>
                                <div style={{display:'flex', justifyContent:"flex-end"}}>
                                    <CSVLink data={this.state.filteredRows} headers={this.state.headers.filter(header => header.value)} target='_blank' enclosingCharacter='"'>
                                        <Button flat primary iconChildren="cloud_download">Download CSV</Button>
                                    </CSVLink>
                                </div>
                            </Cell>
                            <Cell size={12}>
                                {this.state.tableLoading ? this.loader():
                                    <ReactDataGrid
                                        enableCellSelect={true}
                                        columns={this.state.columns.filter(col => !col.hidden).map(col => {
                                            return { ...col, sortable: true, resizable: true }
                                        })}
                                        rowsCount={this.state.filteredRows.length}
                                        rowGetter={this.rowGetter}
                                        onGridSort={(sortColumn, sortDirection) =>
                                            this.handleSetRows(sortColumn, sortDirection)
                                        }
                                        // toolbar={<Toolbar enableFilter={true} />}
                                        minHeight={500}
                                        emptyRowsView={this.emptyRowView}
                                        onAddFilter={this.handleFilter}
                                    />
                                }
                            </Cell>
                        </React.Fragment>

                        : null}
                </Grid>
            </div>
        )
    }
}

export default ActivityLog;